import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { K2DataUploadTable } from "./table";
import { K2DataUploadEdit } from "./edit";

export default function K2DataUpload() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Chargement de fichiers");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<K2DataUploadEdit />} />
      <Route index element={<K2DataUploadTable />} />
    </Routes>
  );
}
